import { render, staticRenderFns } from "./EntityAddresses.vue?vue&type=template&id=3760b1ef"
import script from "./EntityAddresses.vue?vue&type=script&lang=js"
export * from "./EntityAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports